import { memo } from "react";
import { Button, Modal } from "../../../../../../ui";

import styles from "./style.module.scss";

export type SnackbarMessageDetailsProps = {
  title?: string,
  message?: string,
  isOpen: boolean,
  onClose: () => void,
}

export const SnackbarMessageDetails = memo<SnackbarMessageDetailsProps>((
  {
    message,
    title,
    isOpen,
    onClose,
  }) => {

  return (
    <Modal
      title={title}
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      renderDefaultButtons={false}
      buttonsClassName={styles.buttons}
      buttons={
        <Button
          buttonType="primary"
          buttonColorSchema="default"
          onClick={onClose}
        >
          Close
        </Button>
      }
    >
      <pre>{message}</pre>
    </Modal>
  );
});

